import http from '@/libs/http'
export default class TotalHistorialDetalleService {
  getTotalHistorialDetalle (id) {
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/ut-segupharma/facturas/historial_detalle/${id}`)
  }
}
